import { toast } from "react-toastify";
import { getCurrentUser } from "data-handler/ducks/auth";
import { getCurrentSchool } from "data-handler/ducks/schools";
import {
  POST_SUCCESS,
  RESET_SYNC,
  SUCCESS,
  UPDATE,
  getIsAsyncSyncInProgress,
} from "data-handler/ducks/stores";
import { toastFormattedMessages } from "SCConstants";

const customMiddleware = (store: any) => (next: any) => (action: any) => {
  switch (action.type) {
    case UPDATE:
    case RESET_SYNC:
      // Block UPDATE and RESET_SYNC actions during background sync
      const isAsyncSyncInProgress = getIsAsyncSyncInProgress(store.getState());
      if (isAsyncSyncInProgress) {
        toast.warning(
          toastFormattedMessages.find(
            (e) => e.name === "toast.backgroundSyncInProgress"
          )?.label,
          {
            toastId: "blockUpdateDuringSync",
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            draggable: true,
          }
        );
        // Return the action object with a blocked flag so calling code knows it was blocked
        return { ...action, blocked: true };
      }
      // Add the current school and user to the action's payload
      return next({
        ...action,
        school: getCurrentSchool(store.getState()),
        user: getCurrentUser(store.getState()),
      });
    case POST_SUCCESS:
      // Add the current school and user to the action's payload
      return next({
        ...action,
        school: getCurrentSchool(store.getState()),
        user: getCurrentUser(store.getState()),
      });
    case SUCCESS:
      // Add the current user to the action's payload
      return next({
        ...action,
        user: getCurrentUser(store.getState()),
      });
    default:
      return next(action);
  }
};

export default customMiddleware;
